module.exports = __webpack_public_path__ + "static/media/xiaojun-7.jpeg";